export enum MeteringType {
  Hot = 'Hot',
  Cold = 'Cold',

  HotLogical = 'HotLogical',
  ColdLogical = 'ColdLogical',

  UnknownMeteringType = 'UnknownMeteringType'
}